export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.4.10-1155.36",
  commitId: "50afc020b311e3ce61c8745fd20369c59b111383",
  commitTime: "2026-04-10T11:55:36.000Z",
});
